<section class="login-background">
  <app-pattern></app-pattern>
  <mat-card appearance="outlined" class="login-card">
    <app-compact-header></app-compact-header>
    <ng-container *ngIf="!isLoading">
      <ng-container *ngIf="!confirmationSucceed">
        <div class="heading-2 align-left">{{'general.api_email_confirmation_retry_title' | translate}}</div>
        <div class="align-left body-2 bottom-spacer-x2"
             innerHTML="{{ 'general.api_email_confirmation_retry_description' | translate }}"></div>
        <div class="flex flex-column">
          <button mat-flat-button type="button" color="primary" (click)="confirmEmail()">
            {{'general.api_email_confirmation_retry' | translate}}
          </button>
          <button mat-button type="button" [routerLink]="'/login'">
            {{'general.api_general_sign_in' | translate}}
          </button>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isLoading">
      <p>{{ 'general.api_email_confirmation_in_progress' | translate }}</p>
      <div class="align-center">
        <mat-spinner [diameter]="32"></mat-spinner>
      </div>
    </ng-container>
    <div class="align-center version">
      {{ viewService.version }}<ng-container *ngIf="!!viewService.conf.environment"> | {{ viewService.conf.environment }}</ng-container>
    </div>
  </mat-card>
</section>
